import {
  AnchorLinkElement,
  InlineImageElement,
  InterlinkElement,
  LinkElement,
} from 'articleEditor/components/elements';
import {
  BoldMark,
  CodeMark,
  ItalicMark,
  StrikethroughMark,
  UnderlineMark,
} from 'articleEditor/components/marks';
import { DebouncedSave } from 'articleEditor/contexts/savingContext';
import { createInlineImagePopupPlugin } from 'articleEditor/plugins/createInlineImagePopupPlugin';
import { myCreatePlugins } from 'lib-knowledge-document-structure/myCreatePlugins';
import {
  ELEMENT_ANCHOR_LINK,
  ELEMENT_BLOCKQUOTE,
  ELEMENT_CALLOUT,
  ELEMENT_CODE_BLOCK,
  ELEMENT_DIVIDER,
  ELEMENT_EMBED,
  ELEMENT_HEADING_LARGE,
  ELEMENT_HEADING_MEDIUM,
  ELEMENT_HEADING_SMALL,
  ELEMENT_HTML,
  ELEMENT_IMAGE,
  ELEMENT_INLINE_IMAGE,
  ELEMENT_INTERLINK,
  ELEMENT_LI,
  ELEMENT_LINK,
  ELEMENT_OL,
  ELEMENT_PARAGRAPH,
  ELEMENT_TABLE,
  ELEMENT_TD,
  ELEMENT_TH,
  ELEMENT_TR,
  ELEMENT_UL,
  ELEMENT_VIDEO_EMBED,
  MARK_BOLD,
  MARK_CODE,
  MARK_ITALIC,
  MARK_STRIKETHROUGH,
  MARK_UNDERLINE,
  MyPlatePlugin,
} from 'lib-knowledge-document-structure/plateTypes';
import { createDebugPlugin } from 'lib-knowledge-document-structure/plugins/createDebugPlugin';

import {
  BlockQuoteBlock,
  CalloutBlock,
  CodeBlock,
  DividerBlock,
  EmbedBlock,
  HtmlBlock,
  ImageBlock,
  LargeHeadingBlock,
  ListItemBlock,
  MediumHeadingBlock,
  OrderedListBlock,
  ParagraphBlock,
  SmallHeadingBlock,
  TableBlock,
  TableCellBlock,
  TableCellHeaderBlock,
  TableRowBlock,
  UnorderedListBlock,
  VideoBlock,
} from '../components/blocks';
import { createSaveArticlePlugin } from '../plugins/createSaveArticlePlugin';
import { createShortcutPlugin } from '../plugins/shortcut';

type CreateEditorParams = {
  /** Function to save document */
  debouncedSave?: DebouncedSave;
};

export function createEditorPlugins({
  debouncedSave,
}: CreateEditorParams): MyPlatePlugin[] {
  const plugins = [
    createShortcutPlugin(),
    createInlineImagePopupPlugin(),
    debouncedSave &&
      createSaveArticlePlugin({
        options: {
          debouncedSave,
        },
      }),
    createDebugPlugin(),
  ].filter(Boolean) as MyPlatePlugin[];

  return myCreatePlugins(plugins, {
    [ELEMENT_BLOCKQUOTE]: BlockQuoteBlock,
    [ELEMENT_CALLOUT]: CalloutBlock,
    [ELEMENT_CODE_BLOCK]: CodeBlock,
    [ELEMENT_DIVIDER]: DividerBlock,
    [ELEMENT_HEADING_LARGE]: LargeHeadingBlock,
    [ELEMENT_HEADING_MEDIUM]: MediumHeadingBlock,
    [ELEMENT_HEADING_SMALL]: SmallHeadingBlock,
    [ELEMENT_LI]: ListItemBlock,
    [ELEMENT_LINK]: LinkElement,
    [ELEMENT_INTERLINK]: InterlinkElement,
    [ELEMENT_ANCHOR_LINK]: AnchorLinkElement,
    [ELEMENT_INLINE_IMAGE]: InlineImageElement,
    [ELEMENT_OL]: OrderedListBlock,
    [ELEMENT_PARAGRAPH]: ParagraphBlock,
    [ELEMENT_UL]: UnorderedListBlock,
    [ELEMENT_IMAGE]: ImageBlock,
    [ELEMENT_VIDEO_EMBED]: VideoBlock,
    [ELEMENT_EMBED]: EmbedBlock,
    [ELEMENT_HTML]: HtmlBlock,
    [ELEMENT_TABLE]: TableBlock,
    [ELEMENT_TD]: TableCellBlock,
    [ELEMENT_TH]: TableCellHeaderBlock,
    [ELEMENT_TR]: TableRowBlock,
    [MARK_BOLD]: BoldMark,
    [MARK_CODE]: CodeMark,
    [MARK_ITALIC]: ItalicMark,
    [MARK_STRIKETHROUGH]: StrikethroughMark,
    [MARK_UNDERLINE]: UnderlineMark,
  });
}
